<template>
  <v-container>
    <strong>プライバシーポリシー（個人情報保護方針）</strong>
    <p>
      株式会社アバンテクニカ（以下「当社」）は、以下のとおり個人情報保護方針を定め、
      個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性の認識と取組みを
      徹底させることにより、個人情報の保護を推進致します。
    </p>

    <strong>個人情報の管理</strong>
    <p>
      当社は、お客さまの個人情報を正確かつ最新の状態に保ち、
      個人情報への不正アクセス・紛失・破損・改ざん・漏洩などを防止するため、
      セキュリティシステムの維持・管理体制の整備・社員教育の徹底等の必要な措置を講じ、
      安全対策を実施し個人情報の厳重な管理を行ないます。
    </p>

    <strong>個人情報の利用目的</strong>
    <p>
      お客さまからお預かりした個人情報は、
      当社及び商品提供を行う事業者が商品をお渡しすることを目的に個人情報を利用します。
    </p>
    <div>
      <ul>
        <li>お客さまの同意がある場合</li>
        <li>統計情報として集計し、サービス開発資料として利用する場合</li>
        <li>法令に基づき開示することが必要である場合</li>
      </ul>
    </div>

    <strong>個人情報の安全対策</strong>
    <p>
      当社は、個人情報の正確性及び安全性確保のために、
      セキュリティに万全の対策を講じています。
    </p>

    <strong>ご本人の照会</strong>
    <p>
      お客さまがご本人の個人情報の照会・修正・削除などをご希望される場合には、
      ご本人であることを確認の上、対応させていただきます。
    </p>

    <strong>法令、規範の遵守と見直し</strong>
    <p>
      当社は、保有する個人情報に関して適用される日本の法令、
      その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、
      その改善に努めます。
    </p>

    <strong>お問い合せ</strong>
    <p>
      当社の個人情報の取扱に関するお問い合せはこちらの
      <a :href="urlForm">フォーム</a>からご連絡ください。
    </p>

    <p>2022年9月1日 施行</p>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    urlForm: "https://forms.gle/i4XLWvSSpRn5VM4o8", // 問い合わせフォーム
  }),
  created() {
    this.$store.state.title = "Privacy Policy";
  },
};
</script>
